import { render, staticRenderFns } from "./CSVDLGadget.vue?vue&type=template&id=5cd0f574&scoped=true&"
import script from "./CSVDLGadget.vue?vue&type=script&lang=ts&"
export * from "./CSVDLGadget.vue?vue&type=script&lang=ts&"
import style0 from "./CSVDLGadget.vue?vue&type=style&index=0&id=5cd0f574&lang=scss&scoped=true&"
import style1 from "./CSVDLGadget.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd0f574",
  null
  
)

export default component.exports